// extracted by mini-css-extract-plugin
module.exports = {"boxContainer":"style_boxContainer__2MfnA","mainWrap":"style_mainWrap__3JlHY"};